// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UXXZ","largestCol":"styles_largestCol__3Gu9c","smallestCol":"styles_smallestCol__cH7o6"};